import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Text, Heading, ProgressBar, Box, Icon } from 'core/components';
import { addCommas, zeroToText } from 'app/util/utils';

import { FaCamera } from 'react-icons/fa';
import LabelValue from './LabelValue';
import PlanCardContainer from './v2/layout/PlanCardContainer';
import { PlanCardLeftFlex, PlanIconBox, PlanCardMainContentWrapper } from './v2/layout';

// TODO: Delete this Component When License Page Redesign is released to Production
// https://kentik.atlassian.net/browse/CORE-132
@inject('$cost')
@observer
class TrafficCostsPlanCard extends Component {
  state = {
    usedSnapshots: 0
  };

  componentDidMount() {
    const { $cost } = this.props;
    $cost.fetchSnapshotCount().then((usedSnapshots) => {
      this.setState({ usedSnapshots: parseInt(usedSnapshots) || 0 });
    });
  }

  render() {
    const { id, name, max_snapshots, ...rest } = this.props;
    const { usedSnapshots } = this.state;
    const maxSnapshots = Number.isFinite(parseInt(max_snapshots)) ? parseInt(max_snapshots) : 1200;
    const hasUnlimitedCredits = maxSnapshots === -1;

    return (
      <PlanCardContainer {...rest}>
        <PlanCardLeftFlex>
          <PlanIconBox>
            <Icon icon={FaCamera} iconSize={40} color="primary" />
          </PlanIconBox>

          <PlanCardMainContentWrapper>
            <Text color="muted" as="div" mb="4px">
              Traffic Costs
            </Text>

            <Heading level={4} mb={1}>
              {name}{' '}
              <Text fontWeight={200} muted>
                ({id})
              </Text>
            </Heading>

            <Box mt="4px">
              <Box mb={1}>
                <ProgressBar
                  value={maxSnapshots && !hasUnlimitedCredits ? usedSnapshots / maxSnapshots : 0}
                  animate={false}
                  stripes={false}
                  intent={(maxSnapshots ? usedSnapshots / maxSnapshots : 0) > 1 ? 'danger' : 'primary'}
                />
              </Box>
              {!hasUnlimitedCredits && maxSnapshots !== 0 && (
                <>
                  <Text fontWeight="bold">
                    {(maxSnapshots ? usedSnapshots / maxSnapshots : 0) >= 1 ? (
                      '> 100%'
                    ) : (
                      <span>{zeroToText((maxSnapshots ? usedSnapshots / maxSnapshots : 0) * 100, { fix: 1 })}%</span>
                    )}
                  </Text>{' '}
                  credits used
                </>
              )}
            </Box>
          </PlanCardMainContentWrapper>
        </PlanCardLeftFlex>
        <Box>
          <LabelValue label="Used Credits" value={addCommas(usedSnapshots)} />
          <LabelValue label="Max Snapshots" value={hasUnlimitedCredits ? 'Unlimited' : addCommas(maxSnapshots)} />
        </Box>
      </PlanCardContainer>
    );
  }
}

export default TrafficCostsPlanCard;
